module.exports = __webpack_public_path__ + "img/spindle.65792514.png";